import { mapState } from 'vuex'

export const globalMixin = {
  data: () => ({
    appUrl: null
  }),
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 2
      }).format(price)
    }
  },
  computed: {
    ...mapState(['siteData']),
    isMiniPc() {
      return this.$vuetify.breakpoint.smAndUp && this.$vuetify.breakpoint.lgAndDown
    }
  },
  mounted() {
    const { VUE_APP_APP_URL } = process.env

    this.appUrl = VUE_APP_APP_URL
  }
}